<template>
  <div class="device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>

    <div class="devce_name z_ellipsis1">{{ objData.remark }}</div>

    <!-- 上部室外内容块 -->
    <div class="content019_top_wraper">
      <div class="data_019show">
        <div class="data_019_text_desc">
          <div class="data_019_text_title">室外环境</div>
          <div class="data_position_info">
            <img
              class="data_position_019_img"
              :src="computerOutIconSrc"
              alt=""
            />
            <div class="data_position_info_text z_ellipsis1">
              {{ serveShowData.outdoorPollutionDegree }}
            </div>
            <!-- <div > -->
            [
            <img
              class="position_img"
              src="../../../../assets/img/controlpublic/huanjingtance/position.png"
              alt=""
            />
            <div class="data_position_weizhi z_ellipsis1">
              {{ position }}
              <!-- </div> -->
            </div>
            ]
          </div>
        </div>

        <div class="data_019_two_wraper">
          <div class="one_data_show_wraper">
            <div class="one_data_019_number_wraper">
              <div class="one_data_019_number z_ellipsis1">
                {{ serveShowData.outdoorHumidity }}
              </div>
              <div class="one_data_019_unit">%</div>
            </div>
            <div class="one_data_019_desc">室外湿度</div>
          </div>
          <div class="one_data_show_wraper">
            <div class="one_data_019_number_wraper">
              <div
                class="one_data_019_number one_data_019_number_center z_ellipsis1"
              >
                {{ serveShowData.outdoorTemperature }}
              </div>
              <div class="one_data_019_unit one_data_019_unit_center">℃</div>
            </div>
            <div class="one_data_019_desc ">室外温度</div>
          </div>
          <div class="one_data_show_wraper">
            <div class="one_data_019_number_wraper">
              <div class="one_data_019_number z_ellipsis1">
                {{ serveShowData.outdoorPM25 }}
              </div>
              <div class="one_data_019_unit">ug/m3</div>
            </div>
            <div class="one_data_019_desc">室外PM2.5</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下部室内内容块 -->
    <div class="content019_bottom_wraper">
      <div class="data_019show">
        <div class="data_019_text_desc">
          <div class="data_019_text_title">室内环境</div>
          <div class="data_position_info">
            <img
              class="data_position_019_img"
              :src="computerInIconSrc"
              alt=""
            />
            <div class="data_position_info_text z_ellipsis1">
              {{ serveShowData.indoorComfortDegree }}
            </div>
            <!-- <div > -->
            [
            <img
              class="position_img"
              src="../../../../assets/img/controlpublic/huanjingtance/position.png"
              alt=""
            />
            <div class="data_position_weizhi z_ellipsis1">
              {{ objData.regionName }}
              <!-- </div> -->
            </div>
            ]
          </div>
        </div>

        <div class="data_019_two_wraper">
          <div class="one_data_show_wraper">
            <div class="one_data_019_number_wraper">
              <div class="one_data_019_number z_ellipsis1">
                {{ serveShowData.indoorHumidity }}
              </div>
              <div class="one_data_019_unit">%</div>
            </div>
            <div class="one_data_019_desc">室内湿度</div>
          </div>
          <div class="one_data_show_wraper">
            <div class="one_data_019_number_wraper">
              <div
                class="one_data_019_number one_data_019_number_center z_ellipsis1"
              >
                {{ serveShowData.indoorTemperature }}
              </div>
              <div class="one_data_019_unit one_data_019_unit_center">℃</div>
            </div>
            <div class="one_data_019_desc ">室内温度</div>
          </div>
          <div class="one_data_show_wraper">
            <div class="one_data_019_number_wraper">
              <div class="one_data_019_number z_ellipsis1">
                {{ serveShowData.indoorPM25 }}
              </div>
              <div class="one_data_019_unit">ug/m3</div>
            </div>
            <div class="one_data_019_desc">室内PM2.5</div>
          </div>
        </div>

        <div class="data_09_fengexian"></div>

        <div class="data_019_info_show_bottom_wraper">
          <div class="data_019_info_data">
            <div class="data_019_info_name_show">VOC:</div>
            <div class="data_019_info_data_show z_ellipsis1">
              {{ serveShowData.indoorVOC }}
            </div>
            <div class="one_data_019_unit">ug/m3</div>
          </div>
          <div class="one_data_show_019_bottom_fengexian"></div>
          <div class="data_019_info_data">
            <div class="data_019_info_name_show">CO2:</div>
            <div class="data_019_info_data_show z_ellipsis1">
              {{ serveShowData.indoorCO2 }}
            </div>
            <div class="one_data_019_unit">ppm</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { controlBtnRequestHandle } from 'components/content/control-toast/control-toast-classify/device-public-js'
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data() {
    return {
      userControlData: {
        openState: this.objData.openState, ///无用
        openStateValue: this.objData.openStateValue, //无用
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///无用
      }
      // serveShowData: {
      //   indoorCO2: '257',
      //   indoorComfortDegree: '不舒适',
      //   indoorHumidity: '257',
      //   indoorPM25: '257',
      //   indoorTemperature: '25.7',
      //   indoorVOC: '2.57',
      //   outdoorHumidity: '66',
      //   outdoorPM25: '104',
      //   outdoorPollutionDegree: '严重污染',
      //   outdoorTemperature: '2'
      // },
      // position: sessionStorage.getItem('positionCity')
    }
  },
  props: {
    objData: Object, ///要控制的设备数据
    serveShowData: Object,
    position: String
  },
  methods: {
    // device027BtnClickHandle() {
    //   deviceStateFlip(this.userControlData)
    //   console.log(this.userControlData.openState + '用户的设置数据')
    //   controlBtnRequestHandle(this.userControlData, this.objData) ///控制请求服务端的公共方法
    // }
  },
  computed: {
    computerOutIconSrc() {
      ////计算室外空气质量应该显示的图片区域图片应该显示的按钮
      // console.log(this.OneSceneinfo.iconUrl);
      if (this.serveShowData.outdoorPollutionDegree === '优') {
        ///动态绑定图片 需要require
        return require('assets/img/controlpublic/huanjingtance/out1you.png')
      } else if (this.serveShowData.outdoorPollutionDegree === '良') {
        return require('assets/img/controlpublic/huanjingtance/out2liang.png')
      } else if (this.serveShowData.outdoorPollutionDegree === '轻度污染') {
        return require('assets/img/controlpublic/huanjingtance/out3qing.png')
      } else if (this.serveShowData.outdoorPollutionDegree === '中度污染') {
        return require('assets/img/controlpublic/huanjingtance/out4zhong.png')
      } else if (this.serveShowData.outdoorPollutionDegree === '重度污染') {
        return require('assets/img/controlpublic/huanjingtance/out5zhong.png')
      } else if (this.serveShowData.outdoorPollutionDegree === '严重污染') {
        return require('assets/img/controlpublic/huanjingtance/out6yan.png')
      } else {
        ////动态绑定http的url  不需要require
        return require('assets/img/controlpublic/huanjingtance/out1you.png')
      }
    },
    computerInIconSrc() {
      ////计算室内舒适度应该显示的图片区域图片应该显示的按钮
      // console.log(this.OneSceneinfo.iconUrl);
      if (this.serveShowData.indoorComfortDegree === '非常舒适') {
        ///动态绑定图片 需要require
        return require('assets/img/controlpublic/huanjingtance/in1fei.png')
      } else if (this.serveShowData.indoorComfortDegree === '舒适') {
        return require('assets/img/controlpublic/huanjingtance/in2shu.png')
      } else if (this.serveShowData.indoorComfortDegree === '不舒适') {
        return require('assets/img/controlpublic/huanjingtance/in3no.png')
      } else {
        ////动态绑定http的url  不需要require
        return require('assets/img/controlpublic/huanjingtance/in1fei.png')
      }
    }
  },
  watch: {}
}
</script>

<style>
.content019_top_wraper {
  box-sizing: border-box;
  width: 298px;
  height: 150px;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;

  margin: 18px 0px;
  padding: 0px 10px;
}
.content019_bottom_wraper {
  width: 298px;
  height: 200px;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;
  box-sizing: border-box;

  margin: 18px 0px;
  padding: 0px 10px;
}
.data_019show {
  /* width: 250px; */
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;
  flex-wrap: wrap;

  justify-content: flex-start;
  align-items: center;
  /* align-content: center; */
}
.data_019_text_desc {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}
.data_019_text_title {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  background-color: var(--control-outline-color);
  border-radius: 5px;
}
.data_position_info {
  /* width: 180px; */
  font-size: 14px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  justify-content: flex-end;
  align-content: center;
}
.data_position_info img {
  width: 18px;
  height: 18px;
  margin-top: 1px;

  margin-right: 3px;
}
.data_position_info_text {
  max-width: 70px;
  margin-right: 4px;
}
.data_position_weizhi {
  max-width: 70px;
}
.data_019_text_desc .data_position_info .position_img {
  width: 14px;
  height: 14px;
  margin-top: 3px;
  margin-right: 1px;
  margin-left: 1px;
}
.data_019_two_wraper {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  justify-content: space-between;
  align-items: flex-end;
}
.one_data_show_wraper {
  width: 92px;
  display: flex;
  /* height: 100%; */
  flex-direction: column;
  flex-wrap: nowrap;

  align-items: center;
  justify-content: center;
}
.one_data_019_number_wraper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  justify-content: flex-end;
  align-items: center;
}
.one_data_019_number {
  max-width: 65px;
  font-size: 28px;
}
.one_data_019_number_center {
  font-size: 38px;
  max-width: 80px;
}
.one_data_019_desc {
  color: #999999;
  font-size: 14px;
}

.one_data_019_unit {
  color: #999999;
  align-self: flex-end;
  font-size: 12px;
}
div .one_data_019_unit_center {
  color: #999999;

  align-self: flex-start;
  font-size: 12px;
}

.data_09_fengexian {
  width: 100%;
  height: 1px;
  background-color: var(--control-outline-color);
  margin: 13px 0px;
}
.data_019_info_show_bottom_wraper {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.one_data_show_019_bottom_fengexian {
  height: 20px;
  width: 1px;

  background-color: var(--control-outline-color);
}
.data_019_info_data {
  width: 130px;
  /* text-align: center; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  justify-content: center;
  align-items: center;
}

.data_019_info_name_show {
  font-size: 16px;
  color: #ffffff;
}
.data_019_info_data_show {
  display: inline-block;
  font-size: 16px;
  color: #ffffff;
  max-width: 60px;
}
/* /////// */
</style>
